import { render, staticRenderFns } from "./purchasing-prices-view.vue?vue&type=template&id=00d453ea&"
import script from "./purchasing-prices-view.vue?vue&type=script&lang=js&"
export * from "./purchasing-prices-view.vue?vue&type=script&lang=js&"
import style0 from "./purchasing-prices-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports